import React from "react";
import { Route, RouteProps, Redirect, useLocation } from "react-router-dom";
import jwt, { Jwt, JwtPayload } from "jsonwebtoken";

export interface ProtectedRouteProps extends RouteProps {
  redirectPath?: string;
  privileges?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  redirectPath = "/signin",
  privileges,
  ...props 
}) => {
  const location = useLocation(); // Get full location with query params
  const token = localStorage.getItem("token");

  // Extract only the relative path (avoid absolute URLs)
  const redirectTo = encodeURIComponent(
    `${location.pathname}${location.search}`
  );

  if (!token) {
    return <Redirect to={`${redirectPath}?redirect=${redirectTo}`} />;
  }

  if (token) {
    let decodedToken: Jwt | null = jwt.decode(token, { complete: true });
    let dateNow = new Date();
    let payload: JwtPayload | undefined = decodedToken?.payload as JwtPayload;

    if (payload?.exp && payload.exp * 1000 < dateNow.getTime()) {
      localStorage.removeItem("token");
      return <Redirect to={`${redirectPath}?redirect=${redirectTo}`} />;
    }

    if (privileges && !privileges.includes(payload.roles)) {
      return <Redirect to={`${redirectPath}?redirect=${redirectTo}`} />;
    }
  }
 
  return <Route {...props} />;
};

export default ProtectedRoute;






